<template>
  <el-dialog :title="getTitle"
             :visible.sync="showItem"
             :close-on-click-modal="false"
             @close="handleCancel"
             width="40%">
    <el-col :span="24">
      <el-form :model="typeForm"
               :rules="typeRules"
               ref="typeForm"
               label-width="90px"
               class="type-form">
        <el-form-item label="所属父级"
                      prop="type_code">
          <el-select v-model="typeForm.type_code"
                     placeholder="请选择所属父级">
            <el-option v-for="item in typeList"
                       :key="item.id"
                       :label="item.name"
                       :value="item.code">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="code"
                      prop="code">
          <el-input v-model.trim="typeForm.code"
                    placeholder="请输入code"></el-input>
        </el-form-item>
        <el-form-item label="类目名称"
                      prop="name">
          <el-input v-model.trim="typeForm.name"
                    placeholder="请输入类目名称"></el-input>
        </el-form-item>
      </el-form>
    </el-col>
    <span slot="footer"
          class="dialog-footer">
      <el-button @click="handleCancel">取 消</el-button>
      <el-button v-has="'/dict/add' || '/dict/edit'"
                 type="primary"
                 @click="handleConfirm('typeForm')">
        确 定
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import fetch from '@/common/api'
export default {
  props: {
    isShow: {
      type: Boolean
    },
    data: {
      type: Object
    }
  },
  watch: {
    isShow(val) {
      this.showItem = val
    }
  },
  computed: {
    getTitle() {
      return this.data.type === 'add' ? '添加类目' : '编辑类目'
    }
  },
  data() {
    return {
      showItem: this.isShow,
      typeForm: {
        name: '',
        code: '',
        type_code: ''
      },
      typeRules: {
        code: [{ required: true, message: '请输入类型code' }],
        type_code: [{ required: true, message: '请选择所属父级' }],
        name: [{ required: true, message: '请输入类型名称' }]
      },
      typeList: []
    }
  },
  created() {
    if (this.data.type === 'edit') {
      this.getInfo()
    } else {
      this.getTypeList()
      this.typeForm.type_code = this.data.pId
    }
  },
  methods: {
    // 获取列表
    getTypeList() {
      fetch.getTypeList({}).then((data) => {
        data.procData(
          data.res,
          (data) => {
            this.typeList = data.list
          },
          (err) => {
            this.$message.error(err)
          }
        )
      })
    },
    // 获取编辑信息
    getInfo() {
      fetch.getItemInfo({ id: this.data.id }).then((data) => {
        data.procData(
          data.res,
          (data) => {
            this.typeForm = data
          },
          (err) => {
            this.$message.error(err)
          }
        )
      })
    },
    handleConfirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.data.type === 'add') {
            fetch.addItem({ ...this.typeForm }).then((data) => {
              data.procData(
                data.res,
                () => {
                  this.$message.success('操作成功')
                  this.handleCancel('refresh')
                },
                (err) => {
                  this.$message.error(err)
                }
              )
            })
          } else {
            fetch.editItem({ ...this.typeForm }).then((data) => {
              data.procData(
                data.res,
                () => {
                  this.$message.success('操作成功')
                  this.handleCancel('refresh')
                },
                (err) => {
                  this.$message.error(err)
                }
              )
            })
          }
        } else {
          return false
        }
      })
    },
    handleCancel(type) {
      this.$emit('handleClose', type)
    }
  }
}
</script>

<style></style>
